<button class="btn btn-link me-3 mb-2" [attr.data-identifier]="dataIdentifierPrefix + '-filter'"
        (click)="switchToggle()">
    <i class="fa fa-sliders"></i>
    {{ filterLabel }}
</button>
<ng-container *ngIf="showFilters">
    <button class="btn btn-link me-3 mb-2" [attr.data-identifier]="dataIdentifierPrefix + '-apply'"
            (click)="applyFilters()">Apply Filters
    </button>
    <button class="btn btn-link me-3 mb-2" [attr.data-identifier]="dataIdentifierPrefix + '-clear-filter-item'"
            (click)="clearFilters()">Clear All
    </button>
    <div class="d-flex flex-wrap gap-3 mb-2">
        <lib-filter-pill label="Date">
            <div class="input-date input-group input-filter-group">
                <p-date-picker selectionMode="range"
                               [attr.data-identifier]="dataIdentifierPrefix + '-daterange'"
                               placeholder="Any"
                               [(ngModel)]="selectedDateRange"
                               [maxDate]="maxSelectableDate"
                               [readonlyInput]="true"
                               (ngModelChange)="onDateRangeChange()">
                </p-date-picker>
                <span *ngIf="!!selectedDateRange && selectedDateRange.length===2"
                      role="button"
                      tabindex="0"
                      class="ng-clear-wrapper ng-star-inserted"
                      (click)="resetSelectedDate()"
                      (keyup)="resetSelectedDate()">
                      <span aria-hidden="true" class="ng-clear">×</span>
                </span>
            </div>
        </lib-filter-pill>

        <lib-filter-pill label="User" *ngIf="isOrgAdminApp()">
            <div class="input-user input-group input-filter-group" [class.select-open]="userSelect.isOpen()">
                <ng-select #userSelect
                           [items]="(users$ | async) ?? []"
                           [searchable]="false"
                           [(ngModel)]="selectedUser"
                           (open)="focusSearchInput()"
                           [attr.data-identifier]="dataIdentifierPrefix + '-user'"
                           placeholder="Any">
                    <ng-template ng-header-tmp>
                        <input #userSearchInput
                               type="text"
                               placeholder="Search"
                               (input)="onUserSearchInput($event)"/>
                    </ng-template>
                    <ng-template ng-label-tmp let-item="item">
                        <div class="col-3">{{ item.username }}</div>
                    </ng-template>
                    <ng-template ng-option-tmp let-item="item">
                        <div class="col-3">{{ getUserLabel(item) }}</div>
                    </ng-template>
                </ng-select>
            </div>
        </lib-filter-pill>

        <lib-filter-pill label="Organization" *ngIf="!isOrgAdminApp()">
            <div class="input-user input-group input-filter-group" [class.select-open]="organizationSelect.isOpen()">
                <ng-select #organizationSelect
                           [items]="(enterprises$ | async) ?? []"
                           [searchable]="false"
                           [(ngModel)]="selectedEnterprise"
                           (open)="focusEnterpriseSearchInput()"
                           [attr.data-identifier]="dataIdentifierPrefix + '-organization'"
                           placeholder="Any">
                    <ng-template ng-header-tmp>
                        <input #enterpriseSearchInput
                               type="text"
                               placeholder="Search"
                               (input)="onEnterpriseSearchInput($event)"/>
                    </ng-template>
                    <ng-template ng-label-tmp let-item="item">
                        <div class="col-3">{{ item.name }}</div>
                    </ng-template>
                    <ng-template ng-option-tmp let-item="item">
                        <div class="col-3">{{ item.name }}</div>
                    </ng-template>
                </ng-select>
            </div>
        </lib-filter-pill>

        <lib-filter-pill *ngIf="eventNames.length > 1" label="Event Name">
            <div class="input-user input-group input-filter-group" [class.select-open]="eventNameSelect.isOpen()">
                <ng-select #eventNameSelect
                           [items]="eventNames"
                           [(ngModel)]="selectedEventName"
                           bindLabel="label"
                           bindValue="value"
                           [searchable]="false"
                           [attr.data-identifier]="dataIdentifierPrefix + '-eventname'"
                           placeholder="Any">
                    <ng-template ng-label-tmp let-item="item">
                        <div class="col-3">{{ item.label }}</div>
                    </ng-template>
                    <ng-template ng-option-tmp let-item="item">
                        <div class="col-3">{{ item.label }}</div>
                    </ng-template>
                </ng-select>
            </div>
        </lib-filter-pill>
    </div>
</ng-container>
